import { render, staticRenderFns } from "./ProductionStat.vue?vue&type=template&id=3bc7f43a&"
import script from "./ProductionStat.vue?vue&type=script&lang=js&"
export * from "./ProductionStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports